import { AddFreeTrialApi } from 'api/addFreeTrialApi';
import { FreeTrialSubscriptionApi } from 'api/freeTrialSubscriptionApi';
import { AppPath } from 'appConstants';
import { useState, useCallback, useEffect } from 'react';

/** Package lists for the free-trial flows. The add-subscription page uses useFetchOptions. */
export const useFetchPackages = (pathName: string) => {
  const [packages, setPackages] = useState<any>(null);
  const [vatRate, setVatRate] = useState<number | null>(null);
  const [amountOff, setAmountOff] = useState<number | null>(null);
  const [financeEmail, setFinanceEmail] = useState<any>('');
  const [addSecondSchoolUser, setAddSecondSchoolUser] = useState<boolean | null>(null);
  const [chooseAddOrUpgrade, setChooseAddOrUpgrade] = useState<boolean | null>(null);
  const [schoolUsersToUpgrade, setSchoolUsersToUpgrade] = useState<any>(null);
  const [error, setError] = useState<string>('');

  const getSubscriptionsList = useCallback(async () => {
    let result;
    if (pathName === AppPath.NEW_FREE_TRIAL) {
      result = await AddFreeTrialApi.getPackages();
    }
    if (pathName === AppPath.SUBSCRIBE_FREE_TRIAL) {
      result = await FreeTrialSubscriptionApi.getPackages();
    }
    if (result && result.data) {
      if (pathName === AppPath.NEW_FREE_TRIAL) {
        setPackages(result.data.subjects);
      } else if (pathName === AppPath.SUBSCRIBE) {

      } else {
        setPackages(result.data.generalPackages);
        setVatRate(result.data.vatRate);
        setAmountOff(result.data.amountOff);
        setFinanceEmail(result.data.financeEmail);
        setAddSecondSchoolUser(result.data.bAddSecondSchoolUser);
        setChooseAddOrUpgrade(result.data.bChooseAddOrUpgrade);
        setSchoolUsersToUpgrade(result.data.schoolUsersToUpgrade);        
      }
    }

    if (result && result.error) {
      setError(result.error);
    }
  }, []);

  useEffect(() => {
    getSubscriptionsList();
  }, [getSubscriptionsList]);

  return { 
    packages, 
    vatRate, 
    amountOff, 
    financeEmail, 
    addSecondSchoolUser, 
    chooseAddOrUpgrade, 
    schoolUsersToUpgrade, 
    error 
  };
};
